<!-- <ng-container> -->

<ng-container *ngIf="label">
  <app-input-label [label]="label" [isRequired]="isRequired"></app-input-label>
</ng-container>

<mat-form-field
  class="date-range-input d-flex mt-2"
  [ngClass]="{
    focussed: isFocussed,
    error:
      isPickedOpened && (startDateControl.invalid || endDateControl.invalid),
    touched: startDateControl.touched || endDateControl.touched
  }"
>
  <button
    matIconPrefix
    class="button-no-style ms-1 me-2"
    (click)="openRangePicker()"
  >
    <span [innerHTML]="calendarBlackSVG | safeHTML"></span>
  </button>

  <mat-date-range-input [max]="maxDate" [rangePicker]="rangePicker">
    <input
      readonly
      matStartDate
      [formControl]="startDateControl"
      placeholder="Start date"
      (click)="openRangePicker()"
    />
    <input
      readonly
      matEndDate
      [formControl]="endDateControl"
      placeholder="End date"
      (click)="openRangePicker()"
    />
  </mat-date-range-input>

  <ng-container *ngIf="startDateControl.value || endDateControl.value">
    <button
      title="Clear"
      class="button-no-style"
      matIconSuffix
      (click)="resetInput()"
    >
      <img
        width="20"
        height="20"
        src="assets/images/cross-gray-filled.svg"
        alt="Clear"
      />
    </button>
  </ng-container>

  <mat-date-range-picker
    (closed)="closeRangePicker()"
    #rangePicker
  ></mat-date-range-picker>
</mat-form-field>

<ng-container *ngIf="isPickedOpened">
  <ng-container *ngIf="startDateControl.touched">
    <!-- [dynamicErrorMsg]="startDateControl" -->

    <p label="Start date" class="text-xs text-danger mt-1 mb-0"></p>
  </ng-container>
  <ng-container *ngIf="!startDateControl.touched && endDateControl.touched">
    <p label="End date" class="text-xs text-danger mt-1 mb-0"></p>
  </ng-container>
</ng-container>
